var React = require('react');

function PaginationChevronDouble (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero"},React.createElement("path",{"d":"M10.793 1.707 12.207.293 19.914 8l-7.707 7.707-1.414-1.414L17.085 8zM2.207.293 9.914 8l-7.707 7.707-1.414-1.414L7.085 8 .793 1.707z"})));
}

PaginationChevronDouble.defaultProps = {"viewBox":"0 0 20 16"};

module.exports = PaginationChevronDouble;

PaginationChevronDouble.default = PaginationChevronDouble;
